'use client'
import { AlertTitle as ChakraAlertTitle } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { AlertTitleProps } from './alert-title.types'

export default forwardRef(function Alert(
  props: AlertTitleProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraAlertTitle {...props} ref={ref} translate="no" />
})
